import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import JobAppointments from './JobAppointments';

function JobAppointmentsPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Tab Bar */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-full mx-auto px-6 flex items-center gap-1">
          <TabLink to={`/jobs/${id}`} label="Job Details" />
          <TabLink to={`/jobs/${id}/appointments`} label="Appointments" active />
          <TabLink to={`/jobs/${id}/materials`} label="Materials" />
          <TabLink to={`/jobs/${id}/rams`} label="RAMS" />
        </div>
      </div>

      <div className="p-6">
        <JobAppointments jobId={id} />
      </div>
    </div>
  );
}

function TabLink({ to, label, active }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(to)}
      className={`px-4 py-3 text-sm font-medium border-b-2 transition ${
        active
          ? 'border-blue-600 text-blue-700'
          : 'border-transparent text-gray-500 hover:text-gray-700'
      }`}
    >
      {label}
    </button>
  );
}

export default JobAppointmentsPage;
